export const dateFormat = "DD/MM/YYYY" as const;
export const dateTimeFormat = "DD/MM/YYYY HH:mm" as const;
export const dateTimeSecondsFormat = "DD/MM/YYYY HH:mm:ss" as const;